import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup } from '@tmapy/style-guide';
import { LocaleContext } from '../../LocaleContext';
export const MapAttributionForm = ({ showOverMap, onChange }) => {
    return (_jsx(LocaleContext.Consumer, { children: (context) => (_jsx(RadioGroup, { value: `${showOverMap}`, items: [
                { label: context.locale.attribution.outsideOfMap, value: 'false' },
                { label: context.locale.attribution.overMap, value: 'true' },
            ], onChange: onChange })) }));
};
//# sourceMappingURL=form.js.map